<template>
  <div name="library">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Library</h2>

        <UpgradeOption v-if="shouldShowUpgrade" @pressed="showUpgrade()">
        </UpgradeOption>
      </div>
    </header>

    <div class="header-subnav-holder">
      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>

    <router-view />

    <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Resource Library'"
    ></UpgradeModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";


const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const UpgradeOption = () => import("@/components/upgrade/UpgradeOption.vue");

export default {
  name: "library",
  mixins: [upgradeMixin],
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    tabsList() {
      return this.tabs;
    },
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
    };
  },
  created() {
    this.selectedPath = this.PATH_DOCUMENTS;
  },
  mounted() {
    if (this.currentUser.isSecondaryBased) {
      this.tabs = [{ id: 1, name: "Documents", path: "documents" }];
    } else {
      this.tabs = [
        { id: 1, name: "Documents", path: "documents" },
        { id: 2, name: "Videos", path: "videos" },
        {id: 3, name: "Cross Curricular", path: "education"},

      ];
    }
    this.selectedPath = this.tabs[0];
  },
  methods: {
    showPath(object) {
      if (this.selectedPath.id === object.id) {
        return;
      }
      this.selectedPath = object;
      this.$router.push("/library/" + object.path);
    },
  },
  components: {
    UpgradeModal,
    UpgradeOption,
  },
};
</script>

<style scoped>
</style>